<header #header class="header" [attr.aria-label]="'header.label' | translate">
  <div class="header__wave">
    <div class="header__navigation">
      <div class="header__navigation-menu">
        <itc-navigation-menu [headerElement]="header" />
      </div>
      <a class="header__logo" kdsPrefetch routerLink="" [attr.aria-label]="'header.home' | translate"></a>
      <div class="header__top-navigation">
        <itc-top-navigation />
      </div>
    </div>

    <div class="header__actions">
      <div class="header__actions-desktop">
        <itc-notifications *itcPermission="Permission.NotificationsView" />
        <itc-help-menu [id]="HeaderActionItemId.HelpMenu" />
        <a
          *itcPermission="adminSettingsViewPermissionsList"
          kdsPrefetch
          class="header__navigation-item"
          routerLinkActive="header__navigation-item--active"
          showTooltipOnlyOnDesktop
          [attr.aria-label]="'header.settings' | translate"
          [id]="HeaderActionItemId.AdminSettings"
          [kdsTooltip]="'header.settings' | translate"
          [routerLink]="TopNavigationPath.AdminSettings"
          (isActiveChange)="setActiveTopNavigation(TopNavigationPath.AdminSettings, $event)"
        >
          <i aria-hidden="true" class="fa-regular fa-gear fa--header-texticon header__navigation-item-icon"></i>
        </a>
        <itc-profile-menu />
      </div>
      <div class="header__utilities-menu">
        <itc-header-utilities-menu [headerElement]="header" />
      </div>
      <itc-launcher />
    </div>
  </div>
</header>
